module.exports = new __parcel__URL__("jester-jeffrey.596fd8bb.webp").toString();